import React, { useEffect, useState } from "react";
import { Menu, X, Snowflake } from "lucide-react";

const LINKS = [
  { label: "Overview", href: "#overview" },
  { label: "Cities", href: "#cities" },
  { label: "Calendar", href: "#calendar" },
  { label: "Itinerary", href: "#itinerary" },
  { label: "Pricing", href: "#pricing" },
  { label: "Guide", href: "#guide" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#faf5ec]/95 backdrop-blur-md shadow-[0_2px_24px_rgba(26,58,46,0.08)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#top" className="flex items-center gap-2 group">
          <Snowflake
            className={`w-5 h-5 transition-colors ${
              scrolled ? "text-[#1a3a2e]" : "text-[#faf5ec]"
            } group-hover:text-[#c9a55c]`}
            strokeWidth={1.5}
          />
          <div className="flex flex-col leading-none">
            <span
              className={`font-display text-xl tracking-wide ${
                scrolled ? "text-[#1a3a2e]" : "text-[#faf5ec]"
              }`}
            >
              Beyond the Path
            </span>
            <span
              className={`font-script text-base -mt-1 ${
                scrolled ? "text-[#c9a55c]" : "text-[#e9c987]"
              }`}
            >
              travel
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`text-[12px] tracking-[0.22em] uppercase font-medium transition-colors ${
                scrolled
                  ? "text-[#1a3a2e] hover:text-[#c9a55c]"
                  : "text-[#faf5ec] hover:text-[#e9c987]"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="/flyer"
            className={`text-[12px] tracking-[0.22em] uppercase font-medium transition-colors ${
              scrolled
                ? "text-[#c9a55c] hover:text-[#1a3a2e]"
                : "text-[#e9c987] hover:text-[#faf5ec]"
            }`}
          >
            Flyer
          </a>
          <a
            href="#reserve"
            className={scrolled ? "btn-ghost-dark" : "btn-outline"}
          >
            Reserve Spot
          </a>
        </nav>

        <button
          aria-label="Toggle menu"
          className={`lg:hidden p-2 rounded-sm ${
            scrolled ? "text-[#1a3a2e]" : "text-[#faf5ec]"
          }`}
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height] duration-500 bg-[#faf5ec]/98 backdrop-blur-md ${
          open ? "max-h-[420px] border-t border-[#1a3a2e]/10" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4 gap-3">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-[13px] tracking-[0.2em] uppercase font-medium text-[#1a3a2e] hover:text-[#c9a55c] py-2 border-b border-[#1a3a2e]/10"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/flyer"
            onClick={() => setOpen(false)}
            className="text-[13px] tracking-[0.2em] uppercase font-medium text-[#c9a55c] hover:text-[#1a3a2e] py-2 border-b border-[#1a3a2e]/10"
          >
            Flyer
          </a>
          <a
            href="sms:+18188254308"
            onClick={() => setOpen(false)}
            className="text-[13px] tracking-[0.2em] uppercase font-medium text-[#1a3a2e] hover:text-[#c9a55c] py-2 border-b border-[#1a3a2e]/10"
          >
            Text Sophia
          </a>
          <a
            href="#reserve"
            onClick={() => setOpen(false)}
            className="btn-primary justify-center mt-2"
          >
            Reserve Spot
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
